// import Vue from "vue";
import api from "../config/api";
import store from "../store";
export default {
    getProductRisk(num){
        let val = num.toString()
        let levelResult;
        switch (val) {
            case "1" :
                return levelResult = "低风险"
                break;
            case "2" : 
                return levelResult = "中低风险"
                break;
            case "3" : 
                return levelResult = "中风险"
                break;
            case "4" : 
                return levelResult = "中高风险"
                break;
            case "5" : 
                return levelResult = "高风险"
                break;
        }
    },
    /**先去掉冗余的Function */
    // getTimeArea(num){
    //     let areaResult;
    //     switch (num) {
    //         case "0" :
    //             return areaResult = "近1月"
    //             break;
    //         case "1" : 
    //             return areaResult = "近3月"
    //             break;
    //         case "2" : 
    //             return areaResult = "近6月"
    //             break;
    //         case "3" : 
    //             return areaResult = "近1年"
    //             break;
    //         case "4" : 
    //             return areaResult = "成立以来"
    //             break;
    //     }
    // },
    getTimeArea(num){
        let znTime;
        switch (num) {
            case "0" :
                return znTime = "成立以来"
                break;
            case "1" : 
                return znTime = "近1月"
                break;
            case "2" : 
                return znTime = "近3月"
                break;
            case "3" : 
                return znTime = "近6月"
                break;
            case "4" : 
                return znTime = "近1年"
                break;
            case "5" : 
                return znTime = "近3年"
                break;
            case "6" : 
                return znTime = "近5年"
                break;
            case "7" : 
                return znTime = "近1周"
                break;
        }
    },
    getDictionary(){
        Vue.prototype.$post(api.enumerateOrg).then(res => {
            if(res.code===10000){
                let data = res.data
                store.commit('changeDictionary',data)
            }
        })
    },
    getDictionaryList(type){
        let list = store.state.dictionaryData.filter((item)=>{
            return item.name === type
        })
        return list
    },
    getProvinceList(){
        Vue.prototype.$post(api.provinceCityDistrictList).then(res => {
            if(res.code===10000){
                let data = res.data
                store.commit('getProvinceInfo',data)
            }
        })
    },
    getCountryList(){
        Vue.prototype.$post(api.countryLoadLocationList).then(res => {
            if(res.code===10000){
                let data = res.data
                store.commit('getCountryInfo',data)
            }
        })
    },
    getProfessionList(){
        if(Vue.prototype.$store.state.professionList){
            return
        }
        Vue.prototype.$post(api.getType).then(res => {
            if(res.code===10000){
                let data = res.data
                store.commit('changeProfessionList',data)
            }
        })
    },
    fnThrottle (method, delay, duration) {
        var that = this;
        var timer = this.timer;
        var begin = new Date().getTime();
        return function(){
          var context = that;
          var args = arguments;
          var current = new Date().getTime();
          clearTimeout(timer);
          if(current-begin>=duration){
            method.apply(context,args);
            begin=current;
          }else{
            that.timer=setTimeout(function(){
              method.apply(context,args);
            },delay);
          }
        }
      },
      checkProv (val) {
        var pattern = /^[1-9][0-9]/;
        var proCode = {11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门"};
        if(pattern.test(val)) {
            if(proCode[val]) {
                return true;
            }
        }
        return false;
    },
    checkDate (val) {
        var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
        if(pattern.test(val)) {
            var year = val.substring(0, 4);
            var month = val.substring(4, 6);
            var date = val.substring(6, 8);
            var date2 = new Date(year+"-"+month+"-"+date);
            if(date2 && date2.getMonth() == (parseInt(month) - 1)) {
                return true;
            }
        }
        return false;
    },
    checkCode (val) {
        var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
        var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
        var code = val.substring(17);
        if(p.test(val)) {
            var sum = 0;
            for(var i=0;i<17;i++) {
                sum += val[i]*factor[i];
            }
            if(parity[sum % 11] == code.toUpperCase()) {
                return true;
            }
        }
        return false;
    },
    checkCard(val) {
        if(this.checkCode(val)) {
            var date = val.substring(6,14);
            if(this.checkDate(date)) {
                if(this.checkProv(val.substring(0,2))) {
                    return true;
                }
            }
        }
        return false;
    },
    /*
        * 判断平年闰年
        * y:年份数字，四位
        * */
    isOrdinaryYear(y) {
        if((y%4===0 && y % 100 !== 0)|| y % 400 === 0 ){
            return false
        }
        return true;
    },
/*
* 判断是否满足18岁
* time : 毫秒级时间戳，用户选中日期的时间戳
* */
    satisfy(time) {
        let year1 = time.split('-')[0]
        let month1 = time.split('-')[1]
        let day1 = time.split('-')[2]
        var nowDate = new Date(); // 当前时间
        var mouth = nowDate.getMonth()+1 < 10 ? '0' + nowDate.getMonth() + 1 : nowDate.getMonth() + 1;
        var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate();
        var year = nowDate.getFullYear()-18;
        if(year == year1 && day == day1 && mouth == month1){
            return true
        }else{
            var t = new Date(time)
            var d = t.getTime(t)
            if (mouth === 2 && day >= 28){
                day = isOrdinaryYear(year) ? 28 : 29;
            }
            var oldDate = new Date(year+'/'+mouth+'/'+day).getTime();
            return oldDate < d ? false : true;
        }

    },
    // 判断来源
    getRiskSource(type){
        switch(type){
            case '1':
                store.commit('routerJump',"personCenter_page")
                break;
            case '2':
                store.commit('routerJump',"personCenterMore_page")
                break;
            case '3':
                store.commit('routerJump',"privateFund_page")
                break;
            case '4':
                store.commit('routerJump',"publicFund_page")
                break;
            case '5':
                store.commit('routerJump',"verify_page")
                break;
            case '6':
                store.commit('routerJump',"resultRisk_page")
                break;
        }
        // riskSource /风测来源  1-个人中心   2-个人中心-更多   3-私募产品校验   4-公募产品校验  5-一键认证
    },
    gotoFrontPage(that,url,id,riskLevelValue,riskLevel,typeOfPurchase) {
        that.$router.push({
            path: "/productMarketingPreview",
            query: {
                productId: id,
                typeOfPurchase: typeOfPurchase,// 0 表示属于定投类型产品； 1 表示属于正常产品类型 
                riskLevelValue: riskLevelValue,
                riskLevel: riskLevel,
                url: url,
            },
        });
    }
}